import React from 'react';
import {
  Box,
  FormControlLabel,
  makeStyles,
  Radio,
  RadioGroup,
  Typography,
} from '@material-ui/core';
import { EPickupDelivery } from 'features/cart/types/CartTypes';
import { theme } from 'theme';
import { useTranslation } from 'react-i18next';

interface DateTimeComponentProps {
  pickupDeliveryType: EPickupDelivery;
  setPickupDeliveryType: (value: EPickupDelivery) => void;
}

function PickupDeliveryComponent({
  pickupDeliveryType,
  setPickupDeliveryType,
}: DateTimeComponentProps) {
  const classes = useStyles();
  const { t, i18n } = useTranslation();

  const handleChange = (event: any) => {
    if (event.target) {
      setPickupDeliveryType(event.target.value);
    }
  };

  return (
    <Box>
      <Typography className={classes.title}> {t('Choose pickup or delivery')}</Typography>
      <RadioGroup
        aria-label="choosePickupDeliveryGroup"
        name="choosePickupDeliveryGroup"
        className={classes.radioGroup}
        value={pickupDeliveryType}
        onChange={handleChange}
      >
        <FormControlLabel value={EPickupDelivery.PICKUP} control={<Radio />} label="Pickup" />
        <FormControlLabel value={EPickupDelivery.DELIVERY} control={<Radio />} label="Delivery" />
      </RadioGroup>
    </Box>
  );
}

const useStyles = makeStyles({
  title: {
    fontSize: 14,
    lineHeight: '2.4rem',
    color: theme.palette.text.secondary,
  },
  radioGroup: {
    display: 'flex',
    flexDirection: 'row',
    marginBottom: 20,
    color: theme.palette.text.secondary,
  },
});

export default PickupDeliveryComponent;
